import React from 'react'

class ProgressBarAngga extends React.Component{
    constructor(props){
        super(props)
    }
    render(){
        const{progressVal} = this.props
        return(
    		<div className="progress progress-striped active progress-cv">
                <div className="progress-bar progress-bar-info" style={{width: progressVal +'%'}}></div>
            </div>
        )
    }
}

export default ProgressBarAngga